import { useState } from "react"

export const SalesPage = () => {
    const [leftBar, setLeftbar] = useState(false)
    const [showPicker, setShowPicker] = useState(false);
    const [opentxtfld, setOpenTxtFLd] = useState(false)
    const [open_i, setOpenI] = useState(false)
    const [open, setOpen] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [error, setError] = useState({modal:{proceed: false, confirmed: false}})
    const [templateData, setTemplateData] = useState({})
    const [templates, setTemplates] = useState({ preview: false, id: '', section_id: '' })
    const [t_form, setT_Form] = useState({})
    const [listData, setListData] = useState({list: null, current: {value: null, stat: false, view_type: false}, action: {selected: null, modal: false, type: 0, confirmed: false}})
    const [cmtznLoader, setCmtznLoader] = useState(true)
    const [listLoader, setListLoader] = useState(true)
    const [templateLoader, setTemplateLoader] = useState(true)
    const [viewAction, setViewAction] = useState({viewAs:{ modal: false}})
    const [viewdata, setViewData] = useState({})
    const [isExpanded, setIsExpanded] = useState(false);
    const [inftSrcoll, setInftScroll] = useState(false)
    const [lid, setLid] = useState(0)
    const [validateNum, setValidateNum] = useState(false)

    return {
        t_form: { data: t_form, set: setT_Form },
        templates: { data: templates, set: setTemplates },
        leftBar: { data: leftBar, set: setLeftbar },
        showPicker: { data: showPicker, set: setShowPicker },
        opentxtfld: { data: opentxtfld, set: setOpenTxtFLd },
        open_i: { data: open_i, set: setOpenI },
        open: { data: open, set: setOpen },
        openConfirm: { data: openConfirm, set: setOpenConfirm },
        templateData: { data: templateData, set: setTemplateData },
        templateLoader: { data: templateLoader, set: setTemplateLoader },
        cmtznLoader: { data: cmtznLoader, set: setCmtznLoader },
        error: { data: error, set: setError },
        listLoader: {data:listLoader, set:setListLoader},
        listData: {data: listData, set: setListData},
        viewdata: {data: viewdata, set: setViewData},
        viewAction:{data: viewAction, set: setViewAction},
        isExpanded:{data: isExpanded, set: setIsExpanded},
        lid:{data: lid, set: setLid},
        inftSrcoll:{data: inftSrcoll, set: setInftScroll},
        validateNum: {data: validateNum, set: setValidateNum}

    }
}
